import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";

export const notificationApi = createApi({
  reducerPath: "panelNotification",
  baseQuery: axiosBaseQuery(),
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: 30,
  tagTypes: ["Notifications"],
  endpoints: (builder) => ({
    listNotifications: builder.query({
      query: ({ limit = 50 } = {}) => ({
        url: "/api/panel/notifications/list",
        method: "POST",
        data: { limit },
      }),
      providesTags: ["Notifications"],
    }),
    getDeviceStats: builder.query({
      query: () => ({
        url: "/api/panel/notifications/device-stats",
        method: "POST",
        data: {},
      }),
      providesTags: ["Notifications"],
    }),
    sendNotification: builder.mutation({
      query: (body) => ({
        url: "/api/panel/notifications/send",
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useListNotificationsQuery,
  useGetDeviceStatsQuery,
  useSendNotificationMutation,
} = notificationApi;
